import { memo } from 'react';
import { useSelector } from 'react-redux';

import { usePublicPermissions } from '~/components/PublicPermissionsProvider';
import { BoardHeader } from '~/components/v2/components/board/BoardHeader';
import { PublicBoardHeaderActionsCustomFieldsButton } from '~/components/v2/components/board/PublicBoardHeaderActionsCustomFieldsButton';
import { PublicBoardHeaderCustomFields } from '~/components/v2/components/board/PublicBoardHeaderCustomFields';
import { PublicBoardHeaderDescription } from '~/components/v2/components/board/PublicBoardHeaderDescription';
import { PublicBoardHeaderViewControls } from '~/components/v2/components/board/PublicBoardHeaderViewControls';
import { PublicHeaderTitle } from '~/components/v2/components/shared/PublicHeaderTitle';
import { centralizedBoardTitleSelector } from '~/store/centralizedBoard/selectors';
import { canSeeBoardCustomFields } from '~/utils/permissions/boardPermissions';

export const PublicBoardHeader = memo(() => {
  const { permissions } = usePublicPermissions();
  const title = useSelector(centralizedBoardTitleSelector);

  return (
    <BoardHeader
      customFields={<PublicBoardHeaderCustomFields />}
      description={<PublicBoardHeaderDescription />}
      title={title ? <PublicHeaderTitle title={title} dataTestId="PUBLIC_BOARD_HEADER_TITLE" /> : null}
      actions={canSeeBoardCustomFields(permissions) && <PublicBoardHeaderActionsCustomFieldsButton />}
      viewActions={<PublicBoardHeaderViewControls />}
    />
  );
});

PublicBoardHeader.displayName = 'PublicBoardHeader';
